import { render, staticRenderFns } from "./SelectCustomerSupplier.vue?vue&type=template&id=865d1590&scoped=true"
import script from "./SelectCustomerSupplier.vue?vue&type=script&lang=js"
export * from "./SelectCustomerSupplier.vue?vue&type=script&lang=js"
import style0 from "./SelectCustomerSupplier.vue?vue&type=style&index=0&id=865d1590&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "865d1590",
  null
  
)

export default component.exports